var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m48.37,0H0v48.37c0,26.31,21.33,47.63,47.63,47.63h48.37v-48.37C96,21.33,74.67,0,48.37,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--iconBgColor)",
    d: "m46.4,26.99c-6.96-6.96-18.25-6.96-25.22,0-6.96,6.96-6.96,18.25,0,25.22l25.22,25.22,25.22-25.22c6.96-6.96,6.96-18.25,0-25.22-6.96-6.96-18.25-6.96-25.22,0Zm18.28,18.28l-6.93,6.93-11.35,11.35-11.35-11.35-6.93-6.93c-3.13-3.13-3.13-8.21,0-11.35,3.13-3.13,8.21-3.13,11.35,0l6.93,6.93,6.93-6.93c3.13-3.13,8.21-3.13,11.35,0,3.13,3.13,3.13,8.21,0,11.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.67889970e671ca02a1d5c9d655440f7d.svg";
export { ForwardRef as ReactComponent };